import * as z from "zod";
import { null as zNull } from "zod";

export const ManagedMerchantSchema = z.object({
  teamId: z.string(),
  accountId: z.string(),
  name: z.string(),
});

export type ManagedMerchant = z.infer<typeof ManagedMerchantSchema>;

export const getManagedMerchants = {
  name: "getManagedMerchants" as const,
  input: zNull(),
  output: z.object({ merchants: z.array(ManagedMerchantSchema) }),
};
